import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	height: 40px;
	align-items: center;
	width: 200px;
	padding: 0 10px;
	cursor: pointer;

	& > p {
		height: 20px;
	}
`;
